import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBrowse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBrowse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '58a07c9cdbc2f1d2c82543faa33653908089d62e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '28a1b954e0e33c3add807f55775d0ee287493b24', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6b39e5ab3ad11253a6402d37a0af52bcf8f45eff', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5zm1.5 13h12v-12h-12zm15-12h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1zM8.412 14.405a.594.594 0 0 1-.912-.502V9.097c0-.469.516-.753.912-.502l3.796 2.403a.594.594 0 0 1 0 1.004z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-browse", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-browse"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-browse":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBrowse$1);
            }
            break;
    } });
}

const CosmosIconBrowse = CosmosIconBrowse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBrowse, defineCustomElement };
